import useSWR, { SWRResponse } from 'swr';
import { EmployeeEmploymentRelationshipDTO } from '@Models/model.types';
import { addFiltersToApiParam, FilterState } from '@Component/Filter/utils';
import { APIError, ListResponse } from '@tlx/astro-shared';
import { computeUrl } from '@Util/api.ts';
import { APIUrls } from '@Util/urls.ts';

export type SelectAllProps = {
    year: number;
    month: number;
    filters?: FilterState;
};
export function useSelectAllAPI(params: SelectAllProps): SWRResponse<ListResponse<EmployeeEmploymentRelationshipDTO>> {
    return useSWR<ListResponse<EmployeeEmploymentRelationshipDTO>, APIError>(() => getUrl(params));
}

function getUrl(params: SelectAllProps): string {
    const apiParams = new URLSearchParams();

    apiParams.append('year', params.year.toString());
    apiParams.append('month', params.month.toString());

    addFiltersToApiParam(apiParams, params.filters);

    apiParams.append('isSelectable', 'true');
    apiParams.append('fields', 'employee(id),employments(id)');

    return computeUrl(APIUrls.VALID_EMPLOYEES, apiParams);
}
